import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail, ChevronDown } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-216">
      <div className="bg-[#0D7377] text-white py-2" data-id="element-217">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center text-sm" data-id="element-218">
          <div className="flex items-center gap-4" data-id="element-219">
            <a href="tel:08000554969" className="flex items-center gap-1 hover:text-[#E8956B] transition-colors" data-id="element-220">
              <Phone size={14} data-id="element-221" />
              <span data-id="element-222">0800 055 4969</span>
            </a>
            <a href="mailto:info@caringhand.it.com" className="hidden sm:flex items-center gap-1 hover:text-[#E8956B] transition-colors" data-id="element-223">
              <Mail size={14} data-id="element-224" />
              <span data-id="element-225">info@caringhand.it.com</span>
            </a>
          </div>
          <div className="text-xs" data-id="element-226">
            157 Ashley Rd, Hale, Altrincham WA15 9SD
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-227">
        <div className="flex justify-between items-center" data-id="element-228">
          <Link to="/" className="flex items-center" data-id="element-229">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uUxtvxSfHLsYrMhGT1ibkU/llogo435242523523423523.png" alt="Caringhand - Professional Appliance Repair Services" className="h-12 w-auto" data-id="element-230" />
          </Link>
          <nav className="hidden lg:flex items-center gap-6" data-id="element-231">
            <Link to="/" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium" data-id="element-232">
              Home
            </Link>
            <Link to="/repair-services" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium" data-id="element-233">
              Repair Services
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium" data-id="element-234">
              About Us
            </Link>
            <Link to="/faqs" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium" data-id="element-235">
              FAQs
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium" data-id="element-236">
              Contact
            </Link>
            <div className="relative" onMouseEnter={() => setIsPoliciesOpen(true)} onMouseLeave={() => setIsPoliciesOpen(false)} data-id="element-237">
              <button className="flex items-center gap-1 text-gray-700 hover:text-[#0D7377] transition-colors font-medium" data-id="element-238">
                Policies
                <ChevronDown size={16} className={`transition-transform ${isPoliciesOpen ? 'rotate-180' : ''}`} data-id="element-239" />
              </button>
              {isPoliciesOpen && <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg py-2 border border-gray-100" data-id="element-240">
                  <Link to="/terms" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#0D7377] transition-colors" data-id="element-241">
                    Terms & Conditions
                  </Link>
                  <Link to="/privacy" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#0D7377] transition-colors" data-id="element-242">
                    Privacy & Cookies
                  </Link>
                  <Link to="/refund" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#0D7377] transition-colors" data-id="element-243">
                    Refund Policy
                  </Link>
                  <Link to="/cancellation" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#0D7377] transition-colors" data-id="element-244">
                    Cancellation Policy
                  </Link>
                </div>}
            </div>
            <a href="tel:08000554969" className="bg-[#E8956B] text-white px-6 py-2.5 rounded-full font-semibold hover:bg-[#D67D54] transition-colors shadow-md" data-id="element-245">
              Book a Repair
            </a>
          </nav>
          <button className="lg:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-246">
            {isMenuOpen ? <X size={28} data-id="element-247" /> : <Menu size={28} data-id="element-248" />}
          </button>
        </div>
        {isMenuOpen && <nav className="lg:hidden mt-4 pb-4 flex flex-col gap-3" data-id="element-249">
            <Link to="/" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-250">
              Home
            </Link>
            <Link to="/repair-services" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-251">
              Repair Services
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-252">
              About Us
            </Link>
            <Link to="/faqs" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-253">
              FAQs
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-254">
              Contact
            </Link>
            <div className="border-t border-gray-200 pt-3 mt-2" data-id="element-255">
              <p className="text-sm font-semibold text-gray-500 mb-2 px-2" data-id="element-256">
                Policies
              </p>
              <Link to="/terms" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2 pl-4 block" onClick={() => setIsMenuOpen(false)} data-id="element-257">
                Terms & Conditions
              </Link>
              <Link to="/privacy" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2 pl-4 block" onClick={() => setIsMenuOpen(false)} data-id="element-258">
                Privacy & Cookies
              </Link>
              <Link to="/refund" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2 pl-4 block" onClick={() => setIsMenuOpen(false)} data-id="element-259">
                Refund Policy
              </Link>
              <Link to="/cancellation" className="text-gray-700 hover:text-[#0D7377] transition-colors font-medium py-2 pl-4 block" onClick={() => setIsMenuOpen(false)} data-id="element-260">
                Cancellation Policy
              </Link>
            </div>
            <a href="tel:08000554969" className="bg-[#E8956B] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#D67D54] transition-colors text-center shadow-md" data-id="element-261">
              Book a Repair
            </a>
          </nav>}
      </div>
    </header>;
}